module.exports = __webpack_public_path__ + "static/hepatitis-b-938ba39b3f8fb45061645d705416b87e.png";